import { FilteringSupport, TableRowFilter } from 'common/table/filtering-support.interface';
import { CustomEnumFilter, DeclarationStatus } from 'api';

export class ProductsFilteringSupport implements FilteringSupport {
  private customEnumFilters: CustomEnumFilter[];

  constructor(customEnumFilters: CustomEnumFilter[]) {
    this.customEnumFilters = customEnumFilters;
  }

  getFilters(): TableRowFilter[] {
    const filters: TableRowFilter[] = [];
    filters.push({
      type: 'string',
      id: 'filterText',
      defaultValueKey: 'products.filter.nameOrDescription',
    });
    if (this.customEnumFilters.length > 0) {
      filters.push(...this.customEnumFilters.map((filter) => this.toTableRowFilter(filter)));
    } else {
      // Show the intake type filter combo box (with a single option "All intake types") even when there are no product revisions
      filters.push({
        type: 'enum',
        id: 'intakeType',
        defaultValueKey: 'products.filter.allIntakeTypes',
        enumType: {},
      });
    }
    filters.push({
      type: 'enum',
      id: 'declarationStatus',
      defaultValueKey: 'products.filter.allDeclarationStatuses',
      keyTemplate: 'model.productRevision.declarationStatus.',
      enumType: DeclarationStatus,
    });
    return filters;
  }

  toTableRowFilter(customEnumFilter: CustomEnumFilter): TableRowFilter {
    return {
      type: 'enum',
      id: customEnumFilter.columnName,
      defaultValueKey: customEnumFilter.defaultValueKey,
      enumType: customEnumFilter.filterValuesAndLabels,
    };
  }
}
